'use client'

import IconUser from '@/components/assets/icon_user.svg'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Skeleton } from '@/components/ui/skeleton'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { Link } from '@/i18n/navigation'

export default function WorldAvatar() {
  const { roomData } = useCheckEnterRoomContext()

  return (
    <Link
      href={`/profile/${roomData.owner.community_user_id}`}
      className="relative w-fit"
      target="_blank"
    >
      <Avatar className="bg-vive-primary-40 size-12 transition-all">
        <AvatarImage
          src={roomData.owner.head_icon_url}
          alt="world avatar"
          className="object-cover"
        />
        <AvatarFallback>
          {!roomData.owner.head_icon_url ? (
            <IconUser className="bg-vive-primary-40 size-full" />
          ) : (
            <Skeleton className="bg-vive-primary-40 size-full" />
          )}
        </AvatarFallback>
      </Avatar>
    </Link>
  )
}
